import React, { useState } from 'react';
import { Button, Modal, Input, message, Space } from 'antd';
import { PlayCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { updateYoutubeQuestVideos } from '../../utils/api';

/**
 * 手动触发更新 YouTube Quest Videos 脚本的按钮组件
 * 
 * 使用方法:
 * <UpdateYoutubeQuestVideosButton />
 * 
 * 或者指定 questId:
 * <UpdateYoutubeQuestVideosButton questId="123" />
 */
const UpdateYoutubeQuestVideosButton = ({ questId: initialQuestId = null, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [questId, setQuestId] = useState(initialQuestId || '');

  const handleExecute = async () => {
    setLoading(true);
    try {
      const result = await updateYoutubeQuestVideos(questId || null);
      
      if (result.code === 'SCRIPT_EXECUTED') {
        const { processed, succeeded, failed, executionTimeMs } = result.data;
        message.success(
          `脚本执行成功！处理: ${processed}, 成功: ${succeeded}, 失败: ${failed}, 耗时: ${(executionTimeMs / 1000).toFixed(2)}秒`
        );
        
        if (onSuccess) {
          onSuccess(result.data);
        }
        
        setModalVisible(false);
        setQuestId(initialQuestId || '');
      } else {
        message.error(result.message || '脚本执行失败');
      }
    } catch (error) {
      console.error('执行脚本失败:', error);
      const errorMessage = error.message || '执行脚本时发生错误';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    if (initialQuestId) {
      // 如果已经指定了 questId，直接执行
      handleExecute();
    } else {
      // 否则打开模态框让用户输入
      setModalVisible(true);
    }
  };

  return (
    <>
      <Button
        type="primary"
        icon={loading ? <LoadingOutlined /> : <PlayCircleOutlined />}
        onClick={handleClick}
        loading={loading}
        disabled={loading}
      >
        {loading ? '执行中...' : '更新 YouTube Quest Videos'}
      </Button>

      <Modal
        title="更新 YouTube Quest Videos"
        open={modalVisible}
        onOk={handleExecute}
        onCancel={() => {
          setModalVisible(false);
          setQuestId(initialQuestId || '');
        }}
        okText="执行"
        cancelText="取消"
        confirmLoading={loading}
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <div>
            <label>Quest ID (可选):</label>
            <Input
              placeholder="留空则更新所有符合条件的 quests"
              value={questId}
              onChange={(e) => setQuestId(e.target.value)}
              style={{ marginTop: 8 }}
            />
            <div style={{ marginTop: 8, color: '#666', fontSize: '12px' }}>
              如果指定 Quest ID，则只更新该 quest；留空则更新所有类型为 'youtube-video' 且正在进行的 quests
            </div>
          </div>
        </Space>
      </Modal>
    </>
  );
};

export default UpdateYoutubeQuestVideosButton;

